<template lang="pug">
.d-flex.align-center.gap-16.gr-4
  .d-flex.flex-column.gap-4.gr-1.flex-1(
    v-if="label || description"
  )
    template(v-if="label")
      h3 {{ label }}
    template(v-if="description")
      slot(name="description" v-bind="{ description }")
       p.ui-body-2.opacity-60 {{ description }}
  .d-switch.rounded-pill.cursor-pointer(
    :class="containerClass"
    @click="switchValue"
    v-bind="$attrs"
    v-on="$listeners"
  )
    .d-switch__toggle.rounded-circle.d-flex.align-center.justify-center
      v-progress-circular(
        v-if="loading && !disabled"
        :size="size / 2"
        :width="3"
        indeterminate
        color="ui-primary"
      )

</template>

<script>

export default {
  props: {
    value: { type: [Number, String, Boolean], default: false },
    label: { type: String, default: null },
    description: { type: String, default: null },
    falseValue: { type: [Number, String, Boolean], default: false },
    trueValue: { type: [Number, String, Boolean], default: true },
    trueColor: { type: String, default: 'ui-primary' },
    falseColor: { type: String, default: 'ui-neutral lighten-4' },
    size: { type: Number, default: 24 }, // px (height)
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      inputValue: this.value,
    };
  },
  computed: {
    isTrueValue() {
      return this.inputValue === this.trueValue;
    },
    containerClass() {
      const { isTrueValue, trueColor, falseColor, disabled, loading } = this;
      return [
        ...isTrueValue ? ['true-value'] : [],
        ...loading ? ['loading'] : [],
        ...disabled ? ['disabled'] : [
          ...isTrueValue ? [trueColor] : [falseColor],
        ],
      ];
    },
  },
  watch: {
    value: {
      handler(val) {
        this.inputValue = val;
      },
      immediate: true,
    },
    inputValue: {
      handler(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    switchValue() {
      this.inputValue = this.isTrueValue ? this.falseValue : this.trueValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.d-switch {
  $size: calc(v-bind(size) * 1px);
  $width: calc((#{$size} * 5) / 3);
  $transition: margin, background-color .2s ease-in-out;

  height: $size;

  width: $width;
  transition: #{$transition};

  $toggle-margin: 4px;
  $toggle-size: clamp(#{$toggle-margin}, calc(#{$size} - (#{$toggle-margin} * 2)), #{$size});
  &__toggle {
    transition: #{$transition};
    height: $toggle-size;
    width: $toggle-size;
    margin: $toggle-margin;

    background-color: #{$ui-bright};
  }

  &.true-value > .d-switch__toggle {
    margin-left: calc((#{$width} - #{$toggle-size}) - #{$toggle-margin});
  }
  &.loading {
    pointer-events: none;
    opacity: 0.75;
  }
  &.disabled {
    pointer-events: none;
    background-color: #{$ui-neutral-lighten2} !important;
    &.true-value > .d-switch__toggle {
      background-color: #{$ui-neutral-lighten1} !important;
    }
    &:not(.true-value) > .d-switch__toggle {
      background-color: #{$ui-neutral-lighten4} !important;
    }
  }
}
</style>
